import { create } from 'zustand';

export interface CurrentUser {
  login: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  imageUrl: string | null;
  langKey: string | null;
  activated: boolean;
  authorities: string[];
}

interface AuthState {
  user: CurrentUser | null;
  loginModalOpen: boolean;
  setUser(user: CurrentUser | null): void;
  openLoginModal(): void;
  closeLoginModal(): void;
}

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  loginModalOpen: false,
  // When a real user is assigned, also close any open login modal so a
  // stale "Please log in" prompt can't sit on top of an authenticated session.
  setUser: user =>
    set(state => ({ user, loginModalOpen: user ? false : state.loginModalOpen })),
  openLoginModal: () => set({ loginModalOpen: true }),
  closeLoginModal: () => set({ loginModalOpen: false }),
}));

export function hasAnyRole(user: CurrentUser | null, ...roles: string[]): boolean {
  if (!user) return false;
  return roles.some(r => user.authorities.includes(r));
}
